<button type="button" (click)="show()" class="tracking-relaxed btn btn-link">
  <span class="font-medium">{{ defaultOption?.name }}</span>
  <fa-icon class="ml-xs" [icon]="toggleIcon"></fa-icon>
</button>
<cft-filter-dropdown class="!mt-5 sm:!top-0" (selected)="selected($event)" [option$]="options$"></cft-filter-dropdown>
